export default __webpack_public_path__ + "static/media/PMP.049fddad.svg";